var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mf-Ueditor"},[_c('vue-ueditor-wrap',{attrs:{"config":_vm.myConfig,"destroy":false},on:{"ready":_vm.ready},model:{value:(_vm.details),callback:function ($$v) {_vm.details=$$v},expression:"details"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }